import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useWorkspaceAccess } from '../../hooks/useWorkspaceAccess';
import { isWorkspaceAdmin } from '../../utils/permissions';

const RequireAccess = ({ allow = [], admins = false, children }) => {
  const user = useSelector((state) => state.auth.user);
  const { ready, allowed } = useWorkspaceAccess();
  if (!ready) {
    return <div className="py-4 text-center"><Spinner animation="border" size="sm" /></div>;
  }
  if (!allowed(allow) && !(admins && isWorkspaceAdmin(user?.roles))) {
    return (
      <div className="ws-panel">
        <h2 className="ws-panel__title">This area is restricted</h2>
        <p className="text-muted mb-0">Your role does not include this page. An administrator can change it under Settings, in Roles and permissions.</p>
      </div>
    );
  }
  return children || <Outlet />;
};

export default RequireAccess;
